import { Component } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectsettings',
  templateUrl: './projectsettings.component.html',
  styleUrls: ['./projectsettings.component.css']
})
export class ProjectsettingsComponent {
  roletoggle:boolean;
  notificationtoggle:boolean = true;

  toggleNotifications(){
    this.notificationtoggle = !this.notificationtoggle;
    this.roletoggle = false;
  }
  toggleRole(){
    this.roletoggle = !this.roletoggle;
    this.notificationtoggle = false;
  }

}
